/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CollegamentoEsitoDTO } from '../model/models';
import { CollegamentoStatoDTO } from '../model/models';
import { CollegamentoTokenForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { SegnalazioneAccountForm } from '../model/models';
import { SegnalazioneAccountInviataDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CollegaAccountIdentitaDigitaleRequestParams {
    collegamentoTokenForm: CollegamentoTokenForm;
}

export interface SegnalaAccountNonMioRequestParams {
    segnalazioneAccountForm: SegnalazioneAccountForm;
}

export interface StatoCollegamentoAccountRequestParams {
    collegamentoTokenForm: CollegamentoTokenForm;
}


export interface CollegamentoAccountServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Collega l\&#39;accesso SPID/CIE all\&#39;account registrato con lo stesso codice fiscale.
     * Dopo il collegamento il cittadino accede di nuovo con SPID/CIE ed entra nell\&#39;account esistente; email e password continuano a funzionare. Se l\&#39;account non era mai stato attivato viene attivato e l\&#39;email non verificata viene tolta.
     * @endpoint post /api/v1/account/collegamento-identita/collega
* @param requestParameters
     */
    collegaAccountIdentitaDigitale(requestParameters: CollegaAccountIdentitaDigitaleRequestParams, extraHttpRequestParams?: any): Observable<CollegamentoEsitoDTO>;

    /**
     * Segnala che l\&#39;account registrato con il proprio codice fiscale non è stato creato da sé.
     * Salva la segnalazione con i recapiti per essere ricontattati e avvisa l\&#39;assistenza. Con una segnalazione già aperta per lo stesso codice fiscale risponde con quella.
     * @endpoint post /api/v1/account/collegamento-identita/segnalazione
* @param requestParameters
     */
    segnalaAccountNonMio(requestParameters: SegnalaAccountNonMioRequestParams, extraHttpRequestParams?: any): Observable<SegnalazioneAccountInviataDTO>;

    /**
     * Situazione dell\&#39;accesso SPID/CIE rispetto a un account esistente.
     * Dice se l\&#39;accesso è già collegato, se esiste un account registrato con lo stesso codice fiscale (con nome, cognome ed email mascherata) o se c\&#39;è una segnalazione in corso. Nessuna scrittura.
     * @endpoint post /api/v1/account/collegamento-identita/stato
* @param requestParameters
     */
    statoCollegamentoAccount(requestParameters: StatoCollegamentoAccountRequestParams, extraHttpRequestParams?: any): Observable<CollegamentoStatoDTO>;

}
